export default Object.freeze({
  Concise: 'concise',
  Detailed: 'detailed',
  Auto: 'auto',
});
